module.exports = __webpack_public_path__ + "static/img/solutions4.af81a117.png";